import styles from './WallReportModalContent.module.scss';
import { ReactComponent as Close } from 'img/btn-close.svg';
import { useRef } from 'react';
import SvgColorScaleBar from '@features/view/SvgColorScaleBar';
import { REPORT_MODAL_NAMES } from 'config/labels';

export interface WallImageSet {
  one?: string;
  two?: string;
  three?: string;
  four?: string;
  five?: string;
  six?: string;
}

export interface VesselData {
  [label: string]: string | number | null;
}

export interface Props {
  imageSrc?: {
    lawall: WallImageSet;
  };
  wallThicknessValue?:number;
}

const wallKeys = ['one', 'two', 'three', 'four', 'five', 'six'] as const;
const wallKeyMapping = {
  'Anterior': 'one',
  'Posterior': 'six',
  'Left ': 'two',
  'Right': 'three',
  'Head': 'five',
  'Feet': 'four'
}
export default function WallReportModalContent({
  imageSrc,
  wallThicknessValue,
}: Props) {
  const divRef = useRef<HTMLDivElement | null>(null);
  const scaleBarRef = useRef<HTMLDivElement | null>(null);
  const svgRef = useRef<SVGSVGElement | null>(null);
  const wallImages = imageSrc?.lawall || {};

  return (
    <div ref = {divRef} className={styles['WallReport-modal-container']}>
      <div className={styles['WallReport-modal-container-2']}>
        <div className={styles['section1']}>
          {/* <div className={`${styles['title']} text-bold-sm`}>
            LA Wall
          </div> */}
          <div ref={scaleBarRef} className={styles['scale-bar']}>
            <SvgColorScaleBar
              textColor='var(--text-default)'
              variant="modal"
              containerRef = {scaleBarRef}
              svgRef = {svgRef}
              displayValue={wallThicknessValue}
            />
          </div>
          <div className={styles['img-wrapper']}>
            {Object.entries(wallKeyMapping).map(([label,key],index) => (
              <div key={label} className={styles['image-box']}>
                <img src={wallImages[key as keyof WallImageSet]} alt={label} />
                <div className={styles['image-label']}>{label}</div>
              </div>
            ))}
          </div>
        </div>
        {/* <div className={styles['section1']}>
          <div className={`${styles['title']} text-bold-sm`}>
            {FAI_REPORT_MODAL_NAMES.icctable}
          </div>
          <div className={styles['table-wrapper']}>
            <div className={styles['icc-flex-header']}>
              <div>RAI Region</div>
              <div>
                <div className={styles['padding-10px']}>
                  {FAI_REPORT_MODAL_NAMES.interobservervariability}
                </div>
                <div>
                  <div className={styles['display-flex']}>
                    <div>
                      {FAI_REPORT_MODAL_NAMES.icc}
                    </div>
                    <div>
                      {FAI_REPORT_MODAL_NAMES.confidenceinterval}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {Object.entries(tableData).map(([key, data]) => (
              <div key={key} className={styles['icc-flex-row']}>
                <div>{key.toUpperCase()}</div>
                <div>{data['ICC']}</div>
                <div>{data['95CI']}</div>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </div>
  );
}
